import { Controller } from "@hotwired/stimulus"

const round = (num, precision = 2) => +(Math.round(parseFloat(num, 10) + "e+" + precision) + "e-" + precision)
export default class extends Controller {
  static targets = ["tax", "net", "gross"]

  connect() {
    console.log("deal tax connect")
    this.displayPrecision = 2
    this.precision = 7
  }

  calculateGross(net, tax, displayPrecision) {
    return round((net * (1 + tax / 100)), displayPrecision)
  }

  calculateNet(gross, tax, displayPrecision) {
    return round((gross / (1 + tax / 100)), displayPrecision)
  }

  calculateTax(net, gross) {
    return parseInt(net === gross ? 0 : 100 * (gross - net) / net)
  }

  taxInput(_event) {
    const net = parseFloat(this.netTarget.value)
    const tax = parseFloat(this.taxTarget.value)
    const gross = parseFloat(this.grossTarget.value)

    if (net && tax) {
      this.grossTarget.value = this.calculateGross(net, tax, this.displayPrecision)
    } else if (gross && tax) {
      this.netTarget.value = this.calculateNet(gross, tax, this.displayPrecision)
    }
  }

  netInput(event) {
    const net = parseFloat(this.netTarget.value)
    const tax = parseFloat(this.taxTarget.value)
    const gross = parseFloat(this.grossTarget.value)

    if (net && tax) {
      this.grossTarget.value = this.calculateGross(net, tax, this.displayPrecision)
    } else if (net && gross) {
      this.taxTarget.value = this.calculateTax(net, gross, this.displayPrecision)
      this.netInput(event) // to jest po to, żeby zaktualizować też gross po zmianie podatku
    }
  }

  grossInput(event) {
    const net = parseFloat(this.netTarget.value)
    const tax = parseFloat(this.taxTarget.value)
    const gross = parseFloat(this.grossTarget.value)

    if (net && gross) {
      this.taxTarget.value = this.calculateTax(net, gross, this.displayPrecision)
      this.grossInput(event) // to jest po to, żeby zaktualizować też net po zmianie podatku
    } else if (gross && tax) {
      this.netTarget.value = this.calculateNet(gross, tax, this.displayPrecision)
    }
  }
}
